module.exports = __webpack_public_path__ + "static/media/letalk-logo.7617f429.svg";